export default {
      id: "Icon--help-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--help",
      toString: function () {
        return this.url;
      }
    }